///Users/apichet/Downloads/cheetah-insurance-app/src/utils/themeToggle.js
// /src/utils/themeToggle.js
// /Users/apichet/Downloads/cheetah-insurance-app/src/utils/themeToggle.js

export const THEME_KEY = "theme";

export const THEMES = Object.freeze({
  LIGHT: "light-theme",
  DARK: "dark-theme",
});

/** ตรวจว่ารันในเบราว์เซอร์หรือไม่ (กัน SSR/test) */
const hasDOM = () => typeof window !== "undefined" && typeof document !== "undefined";

/** ธีมจาก system preference (ถ้าใช้ได้) */
export function getSystemPreferredTheme() {
  try {
    if (!hasDOM() || !window.matchMedia) return THEMES.LIGHT;
    const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    return prefersDark ? THEMES.DARK : THEMES.LIGHT;
  } catch {
    return THEMES.LIGHT;
  }
}

/** คืนค่าธีมที่บันทึกไว้; ถ้าไม่มีให้ใช้ system preference เป็นค่าเริ่มต้น */
export function getSavedTheme() {
  try {
    if (hasDOM() && window.localStorage) {
      const t = localStorage.getItem(THEME_KEY);
      if (t === THEMES.DARK || t === THEMES.LIGHT) return t;
    }
  } catch {}
  return getSystemPreferredTheme();
}

/** ตั้งธีมบน <html>/<body> และบันทึก (กันค่าไม่ถูกต้องโดย fallback เป็น LIGHT) */
export function applyTheme(theme) {
  if (!hasDOM()) return;

  const next =
    theme === THEMES.DARK || theme === THEMES.LIGHT ? theme : THEMES.LIGHT;

  const html = document.documentElement;
  const body = document.body;

  // ลบธีมเก่า
  html.classList.remove(THEMES.LIGHT, THEMES.DARK);
  body.classList.remove(THEMES.LIGHT, THEMES.DARK);

  // เพิ่มธีมใหม่
  html.classList.add(next);
  body.classList.add(next);

  // เผื่อไลบรารีบางตัวอ่าน data-theme
  html.setAttribute("data-theme", next);

  try {
    localStorage.setItem(THEME_KEY, next);
  } catch {}
}

/** Toggle ธีม light <-> dark และคืนธีมใหม่ */
export function toggleTheme() {
  const current = getSavedTheme();
  const next = current === THEMES.DARK ? THEMES.LIGHT : THEMES.DARK;
  applyTheme(next);
  return next;
}

/** helper สำหรับเรียกตอน boot (optional) */
export function initTheme() {
  applyTheme(getSavedTheme());
}
